import { object, string } from 'yup';

const getFormSchema = () => {
  return object().shape({
    email_address: string()
      .email(polyglot.t('sign_up.invitation.email_field_error'))
      .required(polyglot.t('sign_up.invitation.email_field_error')),
  });
};

export default getFormSchema;
